import { Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Subscription } from 'rxjs';

/** img [appAuthSrc]="filename" [appAuthType]="'accreditamento'" — fetch con Authorization, niente JWT in URL. */
@Directive({
  selector: 'img[appAuthSrc]',
})
export class AuthSrcDirective implements OnChanges, OnDestroy {
  @Input() appAuthSrc = '';
  @Input() appAuthType = 'accreditamento';

  private sub?: Subscription;
  private objectUrl = '';

  constructor(private el: ElementRef<HTMLImageElement>, private api: ApiService) {}

  ngOnChanges(): void {
    this.sub?.unsubscribe();
    this.revoke();
    const name = (this.appAuthSrc || '').toString().split(/[\\/]/).pop() || '';
    if (!name) return;
    this.sub = this.api.getProtectedImageBlob(name, this.appAuthType).subscribe({
      next: (blob) => {
        this.objectUrl = URL.createObjectURL(blob);
        this.el.nativeElement.src = this.objectUrl;
      },
      error: () => {
        this.el.nativeElement.dispatchEvent(new Event('error'));
      },
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.revoke();
  }

  private revoke() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = '';
    }
  }
}
